<div class="container" style="max-width:600px; margin:40px auto; padding:0 16px;">

  <div *ngIf="loading" class="text-center">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div *ngIf="error && !loading">
    <p class="text-center text-danger">No se ha podido cargar la información. El enlace puede ser inválido.</p>
  </div>

  <ng-container *ngIf="!loading && !error && info">

    <div *ngIf="submitted" class="text-center">
      <i class="pi pi-check-circle" style="font-size:3rem; color:green;"></i>
      <h2>Firma guardada correctamente</h2>
      <p>Gracias, {{ info.signerName || info.signerType }}.</p>
    </div>

    <ng-container *ngIf="!submitted">
      <h2>Firma — {{ info.signerType }}</h2>
      <p *ngIf="info.signerName"><strong>{{ info.signerName }}</strong></p>
      <p>Curso: <strong>{{ info.courseName }}</strong></p>

      <div *ngIf="info.alreadySigned" class="p-message p-message-warn" style="padding:12px; margin-bottom:16px; border-radius:4px; background:#fff3cd; border:1px solid #ffc107;">
        Ya existe una firma registrada para este enlace. Si continúas, se sobreescribirá.
      </div>

      <div style="border:1px solid #ccc; border-radius:4px; margin-bottom:12px; background:#fff; touch-action:none;">
        <canvas #canvas width="568" height="200" style="display:block; width:100%; cursor:crosshair;"></canvas>
      </div>

      <div style="display:flex; gap:8px;">
        <button pButton type="button" label="Limpiar" icon="pi pi-refresh" class="p-button-secondary" (click)="clearCanvas()"></button>
        <button pButton type="button" label="Guardar firma" icon="pi pi-save" [disabled]="submitting" (click)="submit()"></button>
      </div>
    </ng-container>

  </ng-container>

</div>
